import React from "react";
import { Link } from "react-router-dom";

export default function AnnouncementBar() {
  return (
    <div className="bg-accent border-b border-border">
      <p className="max-w-7xl mx-auto px-4 py-2.5 text-center text-sm text-brand-navy">
        📋 <strong>New: Lab Health Score</strong> — Free 27-question compliance assessment →{" "}
        <Link to="/health-score" className="font-semibold text-accent-foreground underline underline-offset-2">
          Take the Assessment
        </Link>
      </p>
    </div>
  );
}